/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmConfigurationRoute } from '@jira/router-routes__products-jsm-configuration-routes/src/productsJsmConfigurationRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ProductsJsmConfiguration, { LazyProductsJsmConfiguration } from './ui/index.tsx';

export const productsJsmConfigurationRouteEntry: Route = createEntry(
	productsJsmConfigurationRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-configuration',
		// eslint-disable-next-line no-restricted-syntax
		component: ProductsJsmConfiguration,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],
		forPaint: [LazyAtlassianNavigation, LazyProductsJsmConfiguration],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
